import { render, staticRenderFns } from "./ParentMessage.vue?vue&type=template&id=30c58fbc&scoped=true"
import script from "./ParentMessage.vue?vue&type=script&lang=js"
export * from "./ParentMessage.vue?vue&type=script&lang=js"
import style0 from "./ParentMessage.vue?vue&type=style&index=0&id=30c58fbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c58fbc",
  null
  
)

export default component.exports